<template>
  <div>
    <h3 class="text-primary">
      <i class="fa fa-bookmark me-2"></i> {{ $t("receipts.title") }}
    </h3>
    <p class="text-muted">{{ $t("receipts.info") }}</p>

    <!-- Listă Bonuri -->
    <div class="table-responsive" v-if="receipts.length">
      <table class="table table-striped table-hover rounded">
        <thead class="bg-primary text-white">
          <tr class="text-center">
            <th><i class="fa fa-hashtag me-1"></i> {{ $t("receipts.receiptId") }}</th>
            <th><i class="fa fa-user me-1"></i> {{ $t("receipts.client") }}</th>
            <th><i class="fa fa-calendar me-1"></i> {{ $t("receipts.date") }}</th>
            <th><i class="fa fa-clock-o me-1"></i> {{ $t("receipts.time") }}</th>
            <th><i class="fa fa-credit-card me-1"></i> {{ $t("receipts.paymentMethod") }}</th>
            <th><i class="fa fa-euro me-1"></i> {{ $t("receipts.totalEur") }}</th>
            <th><i class="fa fa-coins me-1"></i> {{ $t("receipts.totalRon") }}</th>
            <th><i class="fa fa-cogs me-1"></i> {{ $t("receipts.actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="receipt in receipts" :key="receipt.id" class="text-center">
            <td>#{{ receipt.id }}</td>
            <td>{{ receipt.cui }}</td>
            <td>{{ formatDate(receipt.created_at) }}</td>
            <td>{{ formatTime(receipt.created_at) }}</td>
            <td>
              <span class="badge" :class="getPaymentClass(receipt.payment_type)">
                {{ receipt.payment_type }} ({{ receipt.payment_method }})
              </span>
            </td>
            <td>{{ receipt.total_price_eur }} EUR</td>
            <td>{{ receipt.total_price_ron }} RON</td>
            <td>
              <button class="btn btn-outline-primary btn-sm d-flex align-items-center" @click="viewReceiptItems(receipt.id)">
                <i class="fa fa-bookmark me-1"></i> {{ $t("receipts.viewItems") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal pentru Produse -->
    <div v-if="selectedReceiptItems.length" class="modal fade show d-block">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title"><i class="fa fa-box-open me-2"></i> {{ $t("receipts.products") }}</h5>
            <button type="button" class="btn-close" @click="selectedReceiptItems = []"></button>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>{{ $t("receipts.productName") }}</th>
                  <th>{{ $t("receipts.quantity") }}</th>
                  <th>{{ $t("receipts.unitPrice") }}</th>
                  <th>{{ $t("receipts.totalPrice") }}</th>
                  <th>{{ $t("receipts.details") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in selectedReceiptItems" :key="item.product_name">
                  <td>{{ item.product_name }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.price_per_unit }}</td>
                  <td>{{ item.total_price }}</td>
                  <td>
                    <ul class="list-unstyled mb-0">
                      <li v-for="(value, key) in item.details" :key="key">
                        <strong>{{ key }}:</strong> {{ value }}
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="selectedReceiptItems = []">
              <i class="fa fa-times"></i> {{ $t("receipts.close") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Mesaj dacă nu există bonuri -->
<!-- Mesaj dacă nu există bonuri -->
<div v-if="!receipts.length" class="alert alert-warning text-center">
  <i class="fa fa-info-circle me-2"></i> {{ $t("receipts.noReceipts") }}
</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BonurileMele",
  data() {
    return {
      receipts: [],
      selectedReceiptItems: [],
    };
  },
  async mounted() {
    await this.fetchReceipts();
  },
  methods: {
    async fetchReceipts() {
      try {
        const response = await axios.get("https://api.feribot-eurobac.ro/client/api/receipts/", {
          withCredentials: true,
        });
        this.receipts = response.data.receipts;
      } catch (error) {
        console.error("❌ Eroare la preluarea bonurilor:", error);
      }
    },
    async viewReceiptItems(receiptId) {
      try {
        const response = await axios.get(`https://api.feribot-eurobac.ro/client/api/receipts/${receiptId}/items/`, {
          withCredentials: true,
        });
        this.selectedReceiptItems = response.data.items;
      } catch (error) {
        console.error("Eroare la preluarea produselor:", error);
      }
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString("ro-RO", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    formatTime(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleTimeString("ro-RO", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
    },getPaymentClass(type) {
  return {
    Card: "bg-success text-white",
    Cash: "bg-warning text-dark",
    Euro: "bg-info text-white"
  }[type] || "bg-secondary text-white";
}
  }
};
</script>

<style scoped>
/* Stilizare tabel */
.table {
  border-radius: 8px;
  overflow: hidden;
}

/* Butoane */
.btn-outline-light {
  font-size: 0.9rem;
}

/* Modal */
.modal {
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  border-radius: 10px;
}

/* Tabel produse */
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}
</style>


